import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { FormArray, FormControl } from '@ngneat/reactive-forms';
import { CheckBoxStatus } from '../../models/checkbox-status.models';
import { SendCheckboxStatusDataService } from '../../services/send-checkbox-status-data/send-checkbox-status-data.service';

@Component({
  selector: 'pdv-checkbox-status',
  templateUrl: './checkbox-status.component.html',
  styleUrls: ['./checkbox-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxStatusComponent implements OnInit, AfterViewInit {
  @ViewChildren('checkbox_status') checkbox!: QueryList<MatCheckbox>;
  @Input() statusData!: CheckBoxStatus[];
  storage = window.sessionStorage;
  checkboxStatusFormArray = new FormArray<string>([]);

  constructor(
    private readonly sendCheckboxStatusForm: SendCheckboxStatusDataService
  ) { }

  ngOnInit(): void {
    this.checkboxStatusFormArray.valueChanges.subscribe((value) => {
      value = value.map((item) => item.toLowerCase());
      
      if (this.checkbox.first.checked == true && value.length !== this.statusData.length - 1) {
        return;
      }
      this.sendCheckboxStatusForm.checkboxData$$.next(value);

      this.storage.setItem('checkboxStatus', JSON.stringify(value));
    });
  }

  ngAfterViewInit(): void {
    const getCheckboxHistory = this.storage.getItem('checkboxStatus');

    if (!getCheckboxHistory || JSON.parse(getCheckboxHistory).length === 0) {
      this.statusData.forEach((item, index) => {
        item.status !== this.statusData[0].status
          ? this.checkboxStatusFormArray.push(new FormControl(item.status))
          : null;
        this.checkbox.toArray()[index].checked = true;
      });
      this.storage.setItem(
        'checkboxStatus',
        JSON.stringify(this.checkboxStatusFormArray.value)
      );

      return;
    }
    const parseCheckboxHistory = JSON.parse(getCheckboxHistory);

    this.checkboxStatusFormArray.clear();

    this.checkbox.forEach((checkbox) => {
      const checkboxHistory = parseCheckboxHistory.find(
        (item: string) => item.toLowerCase() === checkbox.name?.toLowerCase()
      );

      if (checkboxHistory) {
        checkbox.checked = true;
        this.checkboxStatusFormArray.push(new FormControl(checkboxHistory));
      }

      if (
        this.checkboxStatusFormArray.value.length ===
        this.statusData.length - 1
      ) {
        this.checkbox.first.checked = true;
      }
    });
  }

  setValueFormArray(event: MatCheckboxChange, status: string) {
    const eventChecked = event.checked;
    const firstStatusData = this.statusData[0].status;
    const firstStatusEqualEventStatus = status === firstStatusData;

    if (eventChecked && firstStatusEqualEventStatus) {
      this.checkboxStatusFormArray.clear();

      this.statusData.forEach((item) =>
        item.status !== firstStatusData
          ? this.checkboxStatusFormArray.push(new FormControl(item.status))
          : null
      );

      return this.checkbox.forEach((checkbox) => (checkbox.checked = true));
    }

    if (!eventChecked && firstStatusEqualEventStatus) {
      this.checkboxStatusFormArray.clear();
      return this.checkbox.forEach((checkbox) => (checkbox.checked = false));
    }

    if (eventChecked) {
      this.checkboxStatusFormArray.push(new FormControl(status));

      if (
        this.checkboxStatusFormArray.value.length ===
        this.statusData.length - 1
      )
        this.checkbox.first.checked = true;
      return;
    }

    if (!eventChecked && this.checkbox.first.checked) {
      this.checkbox.first.checked = false;
    }

    const mappedValue = this.checkboxStatusFormArray.value.map(value => value.toLowerCase())

    this.checkboxStatusFormArray.removeAt(
      mappedValue.indexOf(status.toLowerCase())
    );
  }

  getCheckboxStatusFormArray(checkbox: any, status: string) {
    const [checkboxElement] = this.checkbox.filter(
      (item) => item.name === status
    );

    checkboxElement.toggle();

    this.setValueFormArray({ checked: checkboxElement.checked } as any, status);
  }
}
